import { c as _c } from "react/compiler-runtime";
const Location = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M24 4c7.924 0 14.348 6.424 14.348 14.348 0 6.964-4.318 15.306-12.835 25.165L24 45.264l-1.513-1.751C13.97 33.654 9.652 25.312 9.652 18.348 9.652 10.424 16.076 4 24 4zm0 4c-5.715 0-10.348 4.633-10.348 10.348 0 5.179 3.133 11.778 9.486 19.7l.762.937.1.121.862-1.059c6.228-7.766 9.362-14.261 9.483-19.393l.003-.306C34.348 12.633 29.715 8 24 8zm0 4.453a5.105 5.105 0 1 1-.001 10.21A5.105 5.105 0 0 1 24 12.452zm0 4a1.104 1.104 0 1 0 .001 2.209A1.104 1.104 0 0 0 24 16.453z" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default Location;